module.exports = __webpack_public_path__ + "static/img/person.d1072a08.png";